<template>
  <div class="easy-pay">
    <card-widget />
    <div class="flex justify-between mb-5 flex-col md:flex-row">
      <e-select
        v-model="currentTransactionType"
        :options="transactionTypes"
      />
      <e-input
        class="mt-5 md:mt-0 md:w-1/4"
        v-model="searchQuery"
        placeholder="Search"
      />
    </div>
    <!--
      List of all transactions filtered, searched, paginated etc.
    -->
    <transactions-list
      :paginated-transactions="paginatedTransactions"
      :search-query="searchQuery"
    />
    <div
      class="flex md:items-center justify-between flex-col md:flex-row"
      v-show="filteredTransactions.length"
    >
      <!--
        Pagination related code
        1. Pagination
        2. Results per page
        3. Showing results count out of total count
        Note: This can be a custom component as well, but for the sake of simplicity, keeping it here.
      -->
      <div class="flex flex-col md:flex-row gap-5 md:mb-0 mb-5 order-2 md:order-1">
        <pagination
          v-model="currentPage"
          :total-pages="Math.ceil(filteredTransactions.length / perPage)"
        />
        <e-select
          v-model="perPage"
          :options="perPageEnum">
          <template #prepend>Show</template>
          <template #append>payments per page</template>
        </e-select>
      </div>
      <div class="order-1 md:order-2 mb-5 md:mb-0">{{ showingTransactions }}</div>
      <!-- Pagination related code ends -->
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import transactions from '@/data/transactions.js'
import ESelect from '@/components/common/ESelect'
import CardWidget from '@/components/EasyPay/CardWidget'
import EInput from '@/components/common/EInput'
import TransactionsList from '@/components/EasyPay/TransactionsList'

export default {
  name: 'EasyPay',
  data () {
    return {
      allTransactions: transactions,
      transactionTypes: ['All', 'Ongoing Payments', 'Charged', 'Refunded'],
      perPageEnum: [10, 25, 50, 100],
      currentTransactionType: 'Ongoing Payments',
      currentPage: 1,
      perPage: 10,
      searchQuery: ''
    }
  },
  computed: {
    paginatedTransactions () {
      return this.filteredTransactions.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
    },
    filteredTransactions () {
      return this.filterBySearch(this.filterByType(this.allTransactions))
    },
    showingTransactions () {
      const start = (this.currentPage - 1) * this.perPage + 1
      const end = (this.currentPage * this.perPage) - (this.perPage - this.paginatedTransactions.length)
      return `Showing ${start} - ${end} of ${this.filteredTransactions.length} payments`
    }
  },
  methods: {
    filterBySearch (transactions) {
      return transactions.filter(transaction => transaction.client.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
    },
    filterByType (transactions) {
      if (this.currentTransactionType === 'Ongoing Payments') {
        return transactions.filter(transaction => transaction.status !== 'paid' && transaction.status !== 'failed')
      } else if (this.currentTransactionType === 'Charged') {
        return transactions.filter(transaction => transaction.status === 'charged')
      } else if (this.currentTransactionType === 'Refunded') {
        return transactions.filter(transaction => transaction.status === 'refunded')
      } else {
        return transactions
      }
    }
  },
  watch: {
    filteredTransactions () {
      this.currentPage = 1
    },
    perPage () {
      this.currentPage = 1
    }
  },
  components: {
    TransactionsList,
    CardWidget,
    ESelect,
    Pagination,
    EInput
  }
}
</script>
